import { TooltipContent } from "../../InfoTooltip/TooltipModules";
import { TooltipHeader } from "../../InfoTooltip/TooltipModules";
import { InfoTooltip } from "../../InfoTooltip/InfoTooltip";
import React, { Fragment } from "react";

export const BreakdownGraphTooltip = () => {
  const content = (
    <Fragment>
      <TooltipContent>
        The energy graph lets us see your total energy consumption in more
        detail. Look at the gradual increase of your school's energy consumption
        throughout the day and how the weather changes the solar generation. Now
        you see it, now you don't! Try clicking 'Grid consumed' below the graph
        and watch the data disappear. Now click it again to watch it reappear.
      </TooltipContent>
      <TooltipHeader>Check it out!</TooltipHeader>
      <TooltipContent>
        Want to know exactly how much energy was consumed at a certain time of
        the day? Hover over the graph above the time you want to investigate and
        the graph will display the data recorded for you.{" "}
      </TooltipContent>
    </Fragment>
  );

  return <InfoTooltip content={content} />;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/tooltips/BreakdownGraphTooltip.js